<template>
  <div class="box box--wrapperVertical">
    <div class="box-title">
      <h2>WORKS</h2>
    </div>
    <div class="box-content">
      <works-projects :onlyIndex="true" />
    </div>
    <div class="box-content box-readMore">
      <router-link :to="{ name: 'PageWorks' }" class="ui-btn btn--sub1">Read more</router-link>
    </div>
  </div>
</template>

<script>
import WorksProjects from '../common/Projects';
export default {
  components: {
    WorksProjects
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/index/Works.vue